import { usePreloadChampionsLeagueData } from '../pages/ChampionsLeagueGame/hooks';

/**
 * DataPreloader komponent - Smart data preloading strategi
 * 
 * Denne komponent kører i baggrunden og preloader data baseret på:
 * 1. Hvor brugeren er i app'en
 * 2. Hvilken data der sandsynligvis skal bruges næste gang
 * 
 * Strategi: Altid vær ét skridt foran brugerens næste handling
 * 
 * @component
 */
const DataPreloader = () => {
  // Preload Champions League data (hook håndterer selv om det skal skippes)
  usePreloadChampionsLeagueData();

  // Denne komponent renderer intet - den kører bare i baggrunden
  return null;
};

export default DataPreloader;

